import { Link } from "gatsby"
import React, { useState } from "react"
// import striptags from "striptags"

import {
  connectStateResults,
  Highlight,
  Hits,
  Index,
  Snippet,
} from "react-instantsearch-dom"

import TileContentProductAlgolia from "./layouts/products"
import TextualResult from "./layouts/textual"
import './_search-results.scss';

// Language
import { useTranslation } from 'react-i18next';


const HitCount = connectStateResults(({ searchResults }) => {
  const hitCount = searchResults && searchResults.nbHits

  return hitCount > 0 ? (
    <div className="HitCount">
      {hitCount}
    </div>
  ) : null
})


const TotalHitNotFound = connectStateResults(({ allSearchResults, searchState }) => {

  const { t } = useTranslation()
  const totalHits = allSearchResults
    ? Object.values(allSearchResults).reduce((acc, { nbHits }) => acc + nbHits, 0)
    : 0;

  if(totalHits === 0){
    return (
      <div id="search-not-found">
        <span className="searching-for">{t('Nessun risultato trovato per')}</span>
        <span className="searching-query">"{searchState.query}".</span>
        <span className="searching-total-string">{t('Prova con altre parole chiave')}.</span>
      </div>
    )
  } else {
    return null
  }

});

// <Highlight attribute="acfPosts.textModules[0].title" hit={hit} escapeHTML tagName="mark" />

const ProductLayout = ({ hit }) => (
  <TileContentProductAlgolia
    data={hit}
  />
)

const NewsLayout = ({ hit }) => {

	const subtitleHTMLStrip = hit?.acfPosts?.subtitle.replace(/<[^>]*>?/gm, '')

	return (
		<Link to={hit.uri}>
			<span className="title">
				<Highlight attribute="title" hit={hit} tagName="mark" />
			</span>
			<span className="subtitle" dangerouslySetInnerHTML={{__html: subtitleHTMLStrip}}></span>
		</Link>
	)
}

const ApplicationsLayout = ({ hit }) => (
  <Link to={hit.uri}>
    <span className="title">
      <Highlight attribute="title" hit={hit} tagName="mark" />
    </span>
    <Highlight attribute="cptApplicationChildrens.subtitle" hit={hit} escapeHTML tagName="mark" />
  </Link>
)

const CasehistoriesLayout = ({ hit }) => (
  <Link to={hit.uri}>
    <span className="title">
      <Highlight attribute="title" hit={hit} tagName="mark" />
    </span>
    <Highlight attribute="cptApplicationChildrens.subtitle" hit={hit} escapeHTML tagName="mark" />
  </Link>
)

const HitsInIndex = ({ index }) => (
  <Index className="HitsInIndex" indexName={index.name}>
    {index.type === 'products' &&
      <Hits className="Hits" hitComponent={ProductLayout} />
    }
    {index.type === 'news' &&
      <Hits className="Hits" hitComponent={NewsLayout} escapeHTML="true" />
    }
    {index.type === 'applications' &&
      <Hits className="Hits" hitComponent={ApplicationsLayout} />
    }
    {index.type === 'casehistories' &&
      <Hits className="Hits" hitComponent={CasehistoriesLayout} />
    }
  </Index>
)

const HitsCountBar = ({ index }) => (
  <Index className="HitsInIndex" indexName={index.name}>
    <HitCount />
  </Index>
)

const SearchResult = ({ indices, id, className }) => {

  const [selectedItem, setSelectedItem] = useState(0)

  return(
    <React.Fragment>
      <div id={id} className={className}>
        <div comp="search-tabs" className="search-tabs">
          <ul className="nav nav-tabs">
              {indices.map((algoliaIndex, index) => {
                return (
                  <li
                    key={`tab-${index}`}
                    className="nav-item"
                    onClick={() => setSelectedItem(index)}
                  >
                    <div className={`nav-link ${ index === selectedItem ? "active" : "" }`}>
                      <span className="position-relative">
                        {algoliaIndex.title}
                        <HitsCountBar index={algoliaIndex} key={algoliaIndex.name} />
                      </span>
                    </div>
                  </li>
                )
              })}
          </ul>
          <div className="text-module">

            <TotalHitNotFound/>

            {indices?.length &&
              indices.map((algoliaIndex, index) => {
                return (
                  index === selectedItem && (
                    <div key={index} className={'tab-' + algoliaIndex.type}>
                      <HitsInIndex index={algoliaIndex} key={algoliaIndex.name} />
                    </div>
                  )
                )
              })}
          </div>
        </div>

      </div>
    </React.Fragment>
  )

}

export default SearchResult
